export const baseURL = "https://dgu-booth.shop";
